// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { usePrinter } from '../../context/PrinterContext';
// import authService from '../../services/authService';
// import Sidebar from '../Sidebar/Sidebar';
// import './Settings.css';

// const Settings = () => {
//   const navigate = useNavigate();
//   const { status, connectPrinter, printTest } = usePrinter();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       navigate('/login');
//       return;
//     }

//     // Get current user
//     const currentUser = authService.getCurrentUser();
//     setUser(currentUser);
//   }, [navigate]);

//   const toggleSidebar = () => {
//     setShowSidebar(!showSidebar);
//   };

//   const closeSidebar = () => {
//     setShowSidebar(false);
//   };

//   return (
//     <div className="settings-page">
//       {/* Sidebar */}
//       <Sidebar isOpen={showSidebar} onClose={closeSidebar} />
      
//       {/* Sidebar Overlay */}
//       {showSidebar && (
//         <div 
//           className="sidebar-overlay active"
//           onClick={closeSidebar}
//         />
//       )}

//       {/* Header with Menu Button */}
//       <header className="header">
//         <div className="header-content">
//           <div className="header-left">
//             <button className="icon-btn" onClick={toggleSidebar}>
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <line x1="3" y1="12" x2="21" y2="12"></line>
//                 <line x1="3" y1="6" x2="21" y2="6"></line>
//                 <line x1="3" y1="18" x2="21" y2="18"></line>
//               </svg>
//             </button>
//             <div className="header-title">App Settings</div>
//           </div>
          
//           {/* {user && (
//             <div className="user-info">
//               <span className="user-name">{user.firstName} {user.lastName}</span>
//               <div className="user-role">
//                 <i className="fas fa-user-tag"></i>
//                 <span>{user.role}</span>
//               </div>
//             </div>
//           )} */}
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="container">
//         <div className="card settings-card">
//           <h2 className="card-title">
//             <i className="fas fa-cog"></i>
//             Application Settings
//           </h2>
          
//           <div className="settings-section">
//             <div className="setting-card">
//               <h3><i className="fas fa-print"></i> Thermal Printer</h3>
//               <div className="setting-info">
//                 <p>Status: 
//                   <span className={`status-badge ${status.toLowerCase()}`}>
//                     {status}
//                     {status === 'Connected' && <i className="fas fa-check-circle"></i>}
//                     {status === 'Disconnected' && <i className="fas fa-times-circle"></i>}
//                     {status === 'Connecting' && <i className="fas fa-sync-alt fa-spin"></i>}
//                   </span>
//                 </p>
                
//                 <div className="setting-description">
//                   <p><i className="fas fa-info-circle"></i> Connect your thermal printer to print receipts and invoices.</p>
//                 </div>
                
//                 <div className="button-group">
//                   <button 
//                     className="btn-primary" 
//                     onClick={connectPrinter}
//                     disabled={status === 'Connected' || status === 'Connecting'}
//                   >
//                     {status === 'Connected' ? (
//                       <>
//                         <i className="fas fa-link"></i> Printer Linked
//                       </>
//                     ) : status === 'Connecting' ? (
//                       <>
//                         <i className="fas fa-spinner fa-spin"></i> Connecting...
//                       </>
//                     ) : (
//                       <>
//                         <i className="fas fa-plug"></i> Connect Printer
//                       </>
//                     )}
//                   </button>

//                   <button 
//                     className="btn-secondary" 
//                     onClick={printTest}
//                     disabled={status !== 'Connected'}
//                   >
//                     <i className="fas fa-print"></i> Test Print
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Add more settings sections here */}
//             {/* <div className="setting-card">
//               <h3><i className="fas fa-user-shield"></i> Security</h3>
//               <div className="setting-info">
//                 <p>Change your password or update security settings</p>
//                 <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-key"></i> Change Password
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-history"></i> View Activity Log
//                   </button>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="setting-card">
//               <h3><i className="fas fa-bell"></i> Notifications</h3>
//               <div className="setting-info">
//                 <p>Configure how you receive notifications</p>
//                 <div className="toggle-group">
//                   <label className="toggle-label">
//                     <input type="checkbox" defaultChecked />
//                     <span className="toggle-slider"></span>
//                     Email Notifications
//                   </label>
//                   <label className="toggle-label">
//                     <input type="checkbox" defaultChecked />
//                     <span className="toggle-slider"></span>
//                     Push Notifications
//                   </label>
//                   <label className="toggle-label">
//                     <input type="checkbox" />
//                     <span className="toggle-slider"></span>
//                     SMS Alerts
//                   </label>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="setting-card">
//               <h3><i className="fas fa-database"></i> Data Management</h3>
//               <div className="setting-info">
//                 <p>Manage your app data and backups</p>
//                 <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-download"></i> Export Data
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-trash-alt"></i> Clear Cache
//                   </button>
//                 </div>
//               </div>
//             </div> */}

//             <div className="setting-card">
//               <h3><i className="fas fa-info-circle"></i> About</h3>
//               <div className="setting-info">
//                 <div className="about-info">
//                   <p><strong>App Version:</strong> 1.0.0</p>
//                   <p><strong>Last Updated:</strong> January 2025</p>
//                   {/* <p><strong>Developer:</strong> Sayul Digital</p> */}
//                 </div>
//                 {/* <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-question-circle"></i> Help & Support
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-star"></i> Rate App
//                   </button>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Settings;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { usePrinter } from '../../context/PrinterContext';
// import authService from '../../services/authService';
// import Sidebar from '../Sidebar/Sidebar';
// import { BUSINESS_NAME, VERSION } from '../../utils/config';

// /* ── Inline SVG icons — no FA dependency ── */
// const Ic = ({ children, size = 16, color = 'currentColor' }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
//     stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     {children}
//   </svg>
// );

// const IcMenu = () => (
//   <Ic size={20} color="white">
//     <line x1="4" y1="6" x2="20" y2="6"/>
//     <line x1="4" y1="12" x2="20" y2="12"/>
//     <line x1="4" y1="18" x2="20" y2="18"/>
//   </Ic>
// );
// const IcCog = () => (
//   <Ic size={15} color="white">
//     <circle cx="12" cy="12" r="3"/>
//     <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
//   </Ic>
// );
// const IcPrint = ({ color = 'currentColor', size = 16 }) => (
//   <Ic size={size} color={color}>
//     <polyline points="6 9 6 2 18 2 18 9"/>
//     <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
//     <rect x="6" y="14" width="12" height="8"/>
//   </Ic>
// );
// const IcInfo = ({ color = 'currentColor', size = 16 }) => (
//   <Ic size={size} color={color}>
//     <circle cx="12" cy="12" r="10"/>
//     <line x1="12" y1="16" x2="12" y2="12"/>
//     <line x1="12" y1="8" x2="12.01" y2="8"/>
//   </Ic>
// );
// const IcPlug = () => (
//   <Ic size={16}>
//     <path d="M18 6L6 18"/><path d="M7 12l-4.5 4.5"/><path d="M12 7l4.5-4.5"/>
//     <path d="M6 18l-1.5 1.5a2.12 2.12 0 0 0 3 3L9 21"/>
//     <path d="M18 6l1.5-1.5a2.12 2.12 0 0 0-3-3L15 3"/>
//   </Ic>
// );
// const IcLink = () => (
//   <Ic size={16}>
//     <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
//     <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
//   </Ic>
// );
// const IcSpinner = () => (
//   <svg width={16} height={16} viewBox="0 0 24 24" fill="none" className="animate-spin">
//     <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
//     <path fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
//   </svg>
// );
// const IcVersion = () => (
//   <Ic size={14} color="white">
//     <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
//   </Ic>
// );
// const IcCalendar = () => (
//   <Ic size={14} color="white">
//     <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
//     <line x1="16" y1="2" x2="16" y2="6"/>
//     <line x1="8" y1="2" x2="8" y2="6"/>
//     <line x1="3" y1="10" x2="21" y2="10"/>
//   </Ic>
// );

// const Settings = () => {
//   const navigate = useNavigate();

//   /* ── All original logic — untouched ── */
//   const { status, connectPrinter, printTest } = usePrinter();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       navigate('/login');
//       return;
//     }

//     // Get current user
//     const currentUser = authService.getCurrentUser();
//     setUser(currentUser);
//   }, [navigate]);

//   const toggleSidebar = () => {
//     setShowSidebar(!showSidebar);
//   };

//   const closeSidebar = () => {
//     setShowSidebar(false);
//   };
//   /* ── End original logic ── */

//   const isConnected  = status === 'Connected';
//   const isConnecting = status === 'Connecting';

//   return (
//     <>
//       {/* Fonts — same as Login/Dashboard/Sidebar */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Lora:wght@600;700&display=swap');
//         .st-body  { font-family:'Outfit',sans-serif; -webkit-font-smoothing:antialiased; }
//         .st-serif { font-family:'Lora',serif; }
//         .st-in { opacity:0; transform:translateY(14px); animation:stUp 0.38s cubic-bezier(.22,.68,0,1.16) forwards; }
//         .st-in:nth-child(1){animation-delay:.04s} .st-in:nth-child(2){animation-delay:.09s} .st-in:nth-child(3){animation-delay:.14s}
//         @keyframes stUp{to{opacity:1;transform:translateY(0)}}
//       `}</style>

//       <div className="st-body min-h-screen bg-[#f5f5ff]">

//         {/* Sidebar — original */}
//         <Sidebar isOpen={showSidebar} onClose={closeSidebar} />

//         {/* Sidebar Overlay — original logic, new style */}
//         {showSidebar && (
//           <div
//             className="fixed inset-0 bg-[#060b4d]/45 backdrop-blur-sm z-40 lg:hidden"
//             onClick={closeSidebar}
//           />
//         )}

//         {/* ══════════════════════
//             HEADER
//         ══════════════════════ */}
//         <header className="sticky top-0 z-30 bg-[#040e99] border-b border-white/10 shadow-[0_2px_8px_rgba(6,11,77,0.12)]">
//           <div className="flex items-center justify-between h-14 px-4 max-w-4xl mx-auto sm:h-16 sm:px-6">

//             <div className="flex items-center gap-3">
//               {/* Hamburger — original onClick={toggleSidebar} */}
//               <button
//                 className="w-9 h-9 rounded-lg bg-white/10 border border-white/15 flex items-center justify-center hover:bg-white/18 transition-colors flex-shrink-0"
//                 onClick={toggleSidebar}
//                 aria-label="Open menu"
//               >
//                 <IcMenu />
//               </button>

//               {/* Brand */}
//               <div className="flex items-center gap-2.5">
//                 <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
//                   <IcCog />
//                 </div>
//                 <span className="st-serif text-[15px] font-bold text-white tracking-[-0.2px]">
//                   App Settings
//                 </span>
//               </div>
//             </div>

//             {/* User pill — original was commented out, keeping hidden but rendered if user exists */}
//             {user && (
//               <div className="hidden sm:flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-3 py-1.5">
//                 <div className="w-5 h-5 rounded-full bg-[#4d6bff]/25 border border-[#4d6bff]/35 flex items-center justify-center text-[9px] font-bold text-[#4d6bff] flex-shrink-0">
//                   {(user.firstName?.[0] || 'U').toUpperCase()}
//                 </div>
//                 <span className="text-[12px] font-semibold text-white/80 truncate">
//                   {user.firstName} {user.lastName}
//                 </span>
//               </div>
//             )}
//           </div>
//         </header>

//         {/* ══════════════════════
//             MAIN CONTENT
//         ══════════════════════ */}
//         <main className="px-4 py-6 max-w-4xl mx-auto sm:px-6 sm:py-8 lg:py-10">

//           {/* Page title */}
//           <div className="st-in mb-6">
//             <h1 className="st-serif text-[22px] font-bold text-[#060b4d] tracking-[-0.4px] sm:text-[26px]">
//               Application Settings
//             </h1>
//             <p className="text-[13px] text-[#4a4d99] mt-1 font-medium">
//               Manage your application preferences and connections.
//             </p>
//           </div>

//           <div className="space-y-4">

//             {/* ──────────────────────────
//                 THERMAL PRINTER CARD
//                 Original: setting-card with h3 "Thermal Printer"
//             ────────────────────────── */}
//             <div className="st-in bg-white rounded-2xl border border-[#c8cbf0] shadow-[0_2px_8px_rgba(6,11,77,0.06)] overflow-hidden">

//               {/* Card header bar */}
//               <div className="bg-[#0613cc] px-5 py-3.5 flex items-center gap-3 border-b border-white/10">
//                 <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
//                   <IcPrint color="white" size={15} />
//                 </div>
//                 <span className="st-serif text-[14px] font-bold text-white tracking-[-0.15px] flex-1">
//                   Thermal Printer
//                 </span>

//                 {/* Status badge — original: status-badge with status.toLowerCase() class */}
//                 <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold border flex-shrink-0 ${
//                   isConnected
//                     ? 'bg-[#4d6bff]/20 border-[#4d6bff]/35 text-[#4d6bff]'
//                     : isConnecting
//                     ? 'bg-yellow-400/20 border-yellow-300/35 text-yellow-200'
//                     : 'bg-white/10 border-white/20 text-white/60'
//                 }`}>
//                   <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
//                     isConnected ? 'bg-[#4d6bff] animate-pulse' : isConnecting ? 'bg-yellow-300' : 'bg-white/35'
//                   }`} />
//                   {status}
//                 </span>
//               </div>

//               {/* Card body */}
//               <div className="px-5 py-5">

//                 {/* setting-description — original: "Connect your thermal printer..." */}
//                 <div className="flex items-start gap-3 p-4 rounded-xl bg-[#f0f1ff] border border-[#b8bcf5] mb-5">
//                   <div className="w-7 h-7 rounded-lg bg-[#0613cc]/12 flex items-center justify-center flex-shrink-0 mt-0.5">
//                     <IcInfo color="#0613cc" size={14} />
//                   </div>
//                   <p className="text-[13.5px] text-[#0e1466] font-medium leading-relaxed">
//                     Connect your thermal printer to print receipts and invoices.
//                   </p>
//                 </div>

//                 {/* button-group — original onClick/disabled logic preserved exactly */}
//                 <div className="flex flex-wrap gap-3">

//                   {/* btn-primary — original: connectPrinter, disabled when Connected or Connecting */}
//                   <button
//                     onClick={connectPrinter}
//                     disabled={status === 'Connected' || status === 'Connecting'}
//                     className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-[13.5px] border min-h-[44px] transition-all duration-200 ${
//                       isConnected
//                         ? 'bg-[#f0f1ff] border-[#b8bcf5] text-[#0613cc] cursor-not-allowed'
//                         : isConnecting
//                         ? 'bg-[#0613cc]/75 border-transparent text-white cursor-not-allowed'
//                         : 'bg-[#0613cc] border-transparent text-white hover:bg-[#040e99] shadow-[0_2px_10px_rgba(6,19,204,0.28)] hover:shadow-[0_4px_16px_rgba(6,19,204,0.34)] hover:-translate-y-px active:scale-[0.98]'
//                     }`}
//                   >
//                     {isConnected ? (
//                       <><span className="text-[#0613cc]"><IcLink /></span> Printer Linked</>
//                     ) : isConnecting ? (
//                       <><IcSpinner /> Connecting...</>
//                     ) : (
//                       <><IcPlug /> Connect Printer</>
//                     )}
//                   </button>

//                   {/* btn-secondary — original: printTest, disabled when not Connected */}
//                   <button
//                     onClick={printTest}
//                     disabled={status !== 'Connected'}
//                     className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-[13.5px] border min-h-[44px] transition-all duration-200 ${
//                       isConnected
//                         ? 'bg-white border-[#c8cbf0] text-[#0e1466] hover:bg-[#f5f5ff] hover:border-[#b8bcf5] shadow-[0_1px_4px_rgba(6,11,77,0.06)] hover:-translate-y-px active:scale-[0.98]'
//                         : 'bg-[#f5f5ff] border-[#c8cbf0] text-[#8a8dc9] cursor-not-allowed'
//                     }`}
//                   >
//                     <span className={isConnected ? 'text-[#0613cc]' : 'text-[#8a8dc9]'}>
//                       <IcPrint size={16} color="currentColor" />
//                     </span>
//                     Test Print
//                   </button>

//                 </div>
//               </div>
//             </div>

//             {/* ──────────────────────────
//                 ABOUT CARD
//                 Original: setting-card with h3 "About", about-info with version & last updated
//             ────────────────────────── */}
//             <div className="st-in bg-white rounded-2xl border border-[#c8cbf0] shadow-[0_2px_8px_rgba(6,11,77,0.06)] overflow-hidden">

//               {/* Card header bar */}
//               <div className="bg-[#0613cc] px-5 py-3.5 flex items-center gap-3 border-b border-white/10">
//                 <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
//                   <IcInfo color="white" size={15} />
//                 </div>
//                 <span className="st-serif text-[14px] font-bold text-white tracking-[-0.15px]">
//                   About
//                 </span>
//               </div>

//               {/* Card body */}
//               <div className="px-5 py-5">
//                 {/* about-info — original: App Version 1.0.0, Last Updated January 2025 */}
//                 <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

//                   <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-[#f5f5ff] border border-[#c8cbf0]">
//                     <div className="w-8 h-8 rounded-lg bg-[#0613cc] flex items-center justify-center flex-shrink-0 shadow-[0_1px_6px_rgba(6,19,204,0.22)]">
//                       <IcVersion />
//                     </div>
//                     <div>
//                       <p className="text-[10.5px] font-bold uppercase tracking-[0.55px] text-[#4a4d99]">App Version</p>
//                       <p className="text-[14px] font-bold text-[#060b4d] mt-0.5">{VERSION}</p>
//                     </div>
//                   </div>

//                   <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-[#f5f5ff] border border-[#c8cbf0]">
//                     <div className="w-8 h-8 rounded-lg bg-[#0613cc] flex items-center justify-center flex-shrink-0 shadow-[0_1px_6px_rgba(6,19,204,0.22)]">
//                       <IcCalendar />
//                     </div>
//                     <div>
//                       <p className="text-[10.5px] font-bold uppercase tracking-[0.55px] text-[#4a4d99]">Last Updated</p>
//                       <p className="text-[14px] font-bold text-[#060b4d] mt-0.5">March 2026</p>
//                     </div>
//                   </div>

//                 </div>

//                 <p className="mt-4 text-[11.5px] text-[#0f6652] font-medium text-center">
//                   Sales App Lite · Powered by{' '}
//                   <a href="https://www.fidesm.dev" target="_blank" rel="noreferrer"
//                     className="text-[#0f6652] font-bold hover:underline">
//                     FIDES Management
//                   </a>
//                 </p>
//               </div>
//             </div>

//           </div>
//         </main>
//       </div>
//     </>
//   );
// };

// export default Settings;

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { usePrinter } from '../../context/PrinterContext';
// import authService from '../../services/authService';
// import Sidebar from '../Sidebar/Sidebar';
// import './Settings.css';

// const Settings = () => {
//   const navigate = useNavigate();
//   const { status, connectPrinter, printTest } = usePrinter();
//   const [showSidebar, setShowSidebar] = useState(false);
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     // Check authentication
//     if (!authService.isAuthenticated()) {
//       navigate('/login');
//       return;
//     }

//     // Get current user
//     const currentUser = authService.getCurrentUser();
//     setUser(currentUser);
//   }, [navigate]);

//   const toggleSidebar = () => {
//     setShowSidebar(!showSidebar);
//   };

//   const closeSidebar = () => {
//     setShowSidebar(false);
//   };

//   return (
//     <div className="settings-page">
//       {/* Sidebar */}
//       <Sidebar isOpen={showSidebar} onClose={closeSidebar} />
      
//       {/* Sidebar Overlay */}
//       {showSidebar && (
//         <div 
//           className="sidebar-overlay active"
//           onClick={closeSidebar}
//         />
//       )}

//       {/* Header with Menu Button */}
//       <header className="header">
//         <div className="header-content">
//           <div className="header-left">
//             <button className="icon-btn" onClick={toggleSidebar}>
//               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                 <line x1="3" y1="12" x2="21" y2="12"></line>
//                 <line x1="3" y1="6" x2="21" y2="6"></line>
//                 <line x1="3" y1="18" x2="21" y2="18"></line>
//               </svg>
//             </button>
//             <div className="header-title">App Settings</div>
//           </div>
          
//           {/* {user && (
//             <div className="user-info">
//               <span className="user-name">{user.firstName} {user.lastName}</span>
//               <div className="user-role">
//                 <i className="fas fa-user-tag"></i>
//                 <span>{user.role}</span>
//               </div>
//             </div>
//           )} */}
//         </div>
//       </header>

//       {/* Main Content */}
//       <div className="container">
//         <div className="card settings-card">
//           <h2 className="card-title">
//             <i className="fas fa-cog"></i>
//             Application Settings
//           </h2>
          
//           <div className="settings-section">
//             <div className="setting-card">
//               <h3><i className="fas fa-print"></i> Thermal Printer</h3>
//               <div className="setting-info">
//                 <p>Status: 
//                   <span className={`status-badge ${status.toLowerCase()}`}>
//                     {status}
//                     {status === 'Connected' && <i className="fas fa-check-circle"></i>}
//                     {status === 'Disconnected' && <i className="fas fa-times-circle"></i>}
//                     {status === 'Connecting' && <i className="fas fa-sync-alt fa-spin"></i>}
//                   </span>
//                 </p>
                
//                 <div className="setting-description">
//                   <p><i className="fas fa-info-circle"></i> Connect your thermal printer to print receipts and invoices.</p>
//                 </div>
                
//                 <div className="button-group">
//                   <button 
//                     className="btn-primary" 
//                     onClick={connectPrinter}
//                     disabled={status === 'Connected' || status === 'Connecting'}
//                   >
//                     {status === 'Connected' ? (
//                       <>
//                         <i className="fas fa-link"></i> Printer Linked
//                       </>
//                     ) : status === 'Connecting' ? (
//                       <>
//                         <i className="fas fa-spinner fa-spin"></i> Connecting...
//                       </>
//                     ) : (
//                       <>
//                         <i className="fas fa-plug"></i> Connect Printer
//                       </>
//                     )}
//                   </button>

//                   <button 
//                     className="btn-secondary" 
//                     onClick={printTest}
//                     disabled={status !== 'Connected'}
//                   >
//                     <i className="fas fa-print"></i> Test Print
//                   </button>
//                 </div>
//               </div>
//             </div>

//             {/* Add more settings sections here */}
//             {/* <div className="setting-card">
//               <h3><i className="fas fa-user-shield"></i> Security</h3>
//               <div className="setting-info">
//                 <p>Change your password or update security settings</p>
//                 <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-key"></i> Change Password
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-history"></i> View Activity Log
//                   </button>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="setting-card">
//               <h3><i className="fas fa-bell"></i> Notifications</h3>
//               <div className="setting-info">
//                 <p>Configure how you receive notifications</p>
//                 <div className="toggle-group">
//                   <label className="toggle-label">
//                     <input type="checkbox" defaultChecked />
//                     <span className="toggle-slider"></span>
//                     Email Notifications
//                   </label>
//                   <label className="toggle-label">
//                     <input type="checkbox" defaultChecked />
//                     <span className="toggle-slider"></span>
//                     Push Notifications
//                   </label>
//                   <label className="toggle-label">
//                     <input type="checkbox" />
//                     <span className="toggle-slider"></span>
//                     SMS Alerts
//                   </label>
//                 </div>
//               </div>
//             </div> */}

//             {/* <div className="setting-card">
//               <h3><i className="fas fa-database"></i> Data Management</h3>
//               <div className="setting-info">
//                 <p>Manage your app data and backups</p>
//                 <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-download"></i> Export Data
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-trash-alt"></i> Clear Cache
//                   </button>
//                 </div>
//               </div>
//             </div> */}

//             <div className="setting-card">
//               <h3><i className="fas fa-info-circle"></i> About</h3>
//               <div className="setting-info">
//                 <div className="about-info">
//                   <p><strong>App Version:</strong> 1.0.0</p>
//                   <p><strong>Last Updated:</strong> January 2025</p>
//                   {/* <p><strong>Developer:</strong> Sayul Digital</p> */}
//                 </div>
//                 {/* <div className="button-group">
//                   <button className="btn-secondary">
//                     <i className="fas fa-question-circle"></i> Help & Support
//                   </button>
//                   <button className="btn-secondary">
//                     <i className="fas fa-star"></i> Rate App
//                   </button>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Settings;

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePrinter } from '../../context/PrinterContext';
import authService from '../../services/authService';
import Sidebar from '../Sidebar/Sidebar';
import { BUSINESS_NAME, VERSION } from '../../utils/config';

/* ── Inline SVG icons — no FA dependency ── */
const Ic = ({ children, size = 16, color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

const IcMenu = () => (
  <Ic size={20} color="white">
    <line x1="4" y1="6" x2="20" y2="6"/>
    <line x1="4" y1="12" x2="20" y2="12"/>
    <line x1="4" y1="18" x2="20" y2="18"/>
  </Ic>
);
const IcCog = () => (
  <Ic size={15} color="white">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
  </Ic>
);
const IcPrint = ({ color = 'currentColor', size = 16 }) => (
  <Ic size={size} color={color}>
    <polyline points="6 9 6 2 18 2 18 9"/>
    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>
    <rect x="6" y="14" width="12" height="8"/>
  </Ic>
);
const IcInfo = ({ color = 'currentColor', size = 16 }) => (
  <Ic size={size} color={color}>
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="16" x2="12" y2="12"/>
    <line x1="12" y1="8" x2="12.01" y2="8"/>
  </Ic>
);
const IcPlug = () => (
  <Ic size={16}>
    <path d="M18 6L6 18"/><path d="M7 12l-4.5 4.5"/><path d="M12 7l4.5-4.5"/>
    <path d="M6 18l-1.5 1.5a2.12 2.12 0 0 0 3 3L9 21"/>
    <path d="M18 6l1.5-1.5a2.12 2.12 0 0 0-3-3L15 3"/>
  </Ic>
);
const IcLink = () => (
  <Ic size={16}>
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
  </Ic>
);
const IcSpinner = () => (
  <svg width={16} height={16} viewBox="0 0 24 24" fill="none" className="animate-spin">
    <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3"/>
    <path fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
  </svg>
);
const IcVersion = () => (
  <Ic size={14} color="white">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </Ic>
);
const IcCalendar = () => (
  <Ic size={14} color="white">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </Ic>
);

const Settings = () => {
  const navigate = useNavigate();

  /* ── All original logic — untouched ── */
  const { status, connectPrinter, printTest } = usePrinter();
  const [showSidebar, setShowSidebar] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check authentication
    if (!authService.isAuthenticated()) {
      navigate('/login');
      return;
    }

    // Get current user
    const currentUser = authService.getCurrentUser();
    setUser(currentUser);
  }, [navigate]);

  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const closeSidebar = () => {
    setShowSidebar(false);
  };
  /* ── End original logic ── */

  const isConnected  = status === 'Connected';
  const isConnecting = status === 'Connecting';

  return (
    <>
      {/* Fonts — same as Login/Dashboard/Sidebar */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Lora:wght@600;700&display=swap');
        .st-body  { font-family:'Outfit',sans-serif; -webkit-font-smoothing:antialiased; }
        .st-serif { font-family:'Lora',serif; }
        .st-in { opacity:0; transform:translateY(14px); animation:stUp 0.38s cubic-bezier(.22,.68,0,1.16) forwards; }
        .st-in:nth-child(1){animation-delay:.04s} .st-in:nth-child(2){animation-delay:.09s} .st-in:nth-child(3){animation-delay:.14s}
        @keyframes stUp{to{opacity:1;transform:translateY(0)}}
      `}</style>

      <div className="st-body min-h-screen bg-[#f5f5ff]">

        {/* Sidebar — original */}
        <Sidebar isOpen={showSidebar} onClose={closeSidebar} />

        {/* Sidebar Overlay — original logic, new style */}
        {showSidebar && (
          <div
            className="fixed inset-0 bg-[#060b4d]/45 backdrop-blur-sm z-40 lg:hidden"
            onClick={closeSidebar}
          />
        )}

        {/* ══════════════════════
            HEADER
        ══════════════════════ */}
        <header className="sticky top-0 z-30 bg-[#040e99] border-b border-white/10 shadow-[0_2px_8px_rgba(6,11,77,0.12)]">
          <div className="flex items-center justify-between h-14 px-4 max-w-4xl mx-auto sm:h-16 sm:px-6">

            <div className="flex items-center gap-3">
              {/* Hamburger — original onClick={toggleSidebar} */}
              <button
                className="w-9 h-9 rounded-lg bg-white/10 border border-white/15 flex items-center justify-center hover:bg-white/18 transition-colors flex-shrink-0"
                onClick={toggleSidebar}
                aria-label="Open menu"
              >
                <IcMenu />
              </button>

              {/* Brand */}
              <div className="flex items-center gap-2.5">
                <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
                  <IcCog />
                </div>
                <span className="st-serif text-[15px] font-bold text-white tracking-[-0.2px]">
                  App Settings
                </span>
              </div>
            </div>

            {/* User pill — original was commented out, keeping hidden but rendered if user exists */}
            {user && (
              <div className="hidden sm:flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-3 py-1.5">
                <div className="w-5 h-5 rounded-full bg-[#4d6bff]/25 border border-[#4d6bff]/35 flex items-center justify-center text-[9px] font-bold text-[#4d6bff] flex-shrink-0">
                  {(user.firstName?.[0] || 'U').toUpperCase()}
                </div>
                <span className="text-[12px] font-semibold text-white/80 truncate">
                  {user.firstName} {user.lastName}
                </span>
              </div>
            )}
          </div>
        </header>

        {/* ══════════════════════
            MAIN CONTENT
        ══════════════════════ */}
        <main className="px-4 py-6 max-w-4xl mx-auto sm:px-6 sm:py-8 lg:py-10">

          {/* Page title */}
          <div className="st-in mb-6">
            <h1 className="st-serif text-[22px] font-bold text-[#060b4d] tracking-[-0.4px] sm:text-[26px]">
              Application Settings
            </h1>
            <p className="text-[13px] text-[#4a4d99] mt-1 font-medium">
              Manage your application preferences and connections.
            </p>
          </div>

          <div className="space-y-4">

            {/* ──────────────────────────
                THERMAL PRINTER CARD
                Original: setting-card with h3 "Thermal Printer"
            ────────────────────────── */}
            <div className="st-in bg-white rounded-2xl border border-[#c8cbf0] shadow-[0_2px_8px_rgba(6,11,77,0.06)] overflow-hidden">

              {/* Card header bar */}
              <div className="bg-[#0613cc] px-5 py-3.5 flex items-center gap-3 border-b border-white/10">
                <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
                  <IcPrint color="white" size={15} />
                </div>
                <span className="st-serif text-[14px] font-bold text-white tracking-[-0.15px] flex-1">
                  Thermal Printer
                </span>

                {/* Status badge — original: status-badge with status.toLowerCase() class */}
                <span className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold border flex-shrink-0 ${
                  isConnected
                    ? 'bg-[#4d6bff]/20 border-[#4d6bff]/35 text-[#4d6bff]'
                    : isConnecting
                    ? 'bg-yellow-400/20 border-yellow-300/35 text-yellow-200'
                    : 'bg-white/10 border-white/20 text-white/60'
                }`}>
                  <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${
                    isConnected ? 'bg-[#4d6bff] animate-pulse' : isConnecting ? 'bg-yellow-300' : 'bg-white/35'
                  }`} />
                  {status}
                </span>
              </div>

              {/* Card body */}
              <div className="px-5 py-5">

                {/* setting-description — original: "Connect your thermal printer..." */}
                <div className="flex items-start gap-3 p-4 rounded-xl bg-[#f0f1ff] border border-[#b8bcf5] mb-5">
                  <div className="w-7 h-7 rounded-lg bg-[#0613cc]/12 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <IcInfo color="#0613cc" size={14} />
                  </div>
                  <p className="text-[13.5px] text-[#0e1466] font-medium leading-relaxed">
                    Connect your thermal printer to print receipts and invoices.
                  </p>
                </div>

                {/* button-group — original onClick/disabled logic preserved exactly */}
                <div className="flex flex-wrap gap-3">

                  {/* btn-primary — original: connectPrinter, disabled when Connected or Connecting */}
                  <button
                    onClick={connectPrinter}
                    disabled={status === 'Connected' || status === 'Connecting'}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-[13.5px] border min-h-[44px] transition-all duration-200 ${
                      isConnected
                        ? 'bg-[#f0f1ff] border-[#b8bcf5] text-[#0613cc] cursor-not-allowed'
                        : isConnecting
                        ? 'bg-[#0613cc]/75 border-transparent text-white cursor-not-allowed'
                        : 'bg-[#0613cc] border-transparent text-white hover:bg-[#040e99] shadow-[0_2px_10px_rgba(6,19,204,0.28)] hover:shadow-[0_4px_16px_rgba(6,19,204,0.34)] hover:-translate-y-px active:scale-[0.98]'
                    }`}
                  >
                    {isConnected ? (
                      <><span className="text-[#0613cc]"><IcLink /></span> Printer Linked</>
                    ) : isConnecting ? (
                      <><IcSpinner /> Connecting...</>
                    ) : (
                      <><IcPlug /> Connect Printer</>
                    )}
                  </button>

                  {/* btn-secondary — original: printTest, disabled when not Connected */}
                  <button
                    onClick={printTest}
                    disabled={status !== 'Connected'}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl font-semibold text-[13.5px] border min-h-[44px] transition-all duration-200 ${
                      isConnected
                        ? 'bg-white border-[#c8cbf0] text-[#0e1466] hover:bg-[#f5f5ff] hover:border-[#b8bcf5] shadow-[0_1px_4px_rgba(6,11,77,0.06)] hover:-translate-y-px active:scale-[0.98]'
                        : 'bg-[#f5f5ff] border-[#c8cbf0] text-[#8a8dc9] cursor-not-allowed'
                    }`}
                  >
                    <span className={isConnected ? 'text-[#0613cc]' : 'text-[#8a8dc9]'}>
                      <IcPrint size={16} color="currentColor" />
                    </span>
                    Test Print
                  </button>

                </div>
              </div>
            </div>

            {/* ──────────────────────────
                ABOUT CARD
                Original: setting-card with h3 "About", about-info with version & last updated
            ────────────────────────── */}
            <div className="st-in bg-white rounded-2xl border border-[#c8cbf0] shadow-[0_2px_8px_rgba(6,11,77,0.06)] overflow-hidden">

              {/* Card header bar */}
              <div className="bg-[#0613cc] px-5 py-3.5 flex items-center gap-3 border-b border-white/10">
                <div className="w-8 h-8 rounded-lg bg-white/15 border border-white/20 flex items-center justify-center flex-shrink-0">
                  <IcInfo color="white" size={15} />
                </div>
                <span className="st-serif text-[14px] font-bold text-white tracking-[-0.15px]">
                  About
                </span>
              </div>

              {/* Card body */}
              <div className="px-5 py-5">
                {/* about-info — original: App Version 1.0.0, Last Updated January 2025 */}
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

                  <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-[#f5f5ff] border border-[#c8cbf0]">
                    <div className="w-8 h-8 rounded-lg bg-[#0613cc] flex items-center justify-center flex-shrink-0 shadow-[0_1px_6px_rgba(6,19,204,0.22)]">
                      <IcVersion />
                    </div>
                    <div>
                      <p className="text-[10.5px] font-bold uppercase tracking-[0.55px] text-[#4a4d99]">App Version</p>
                      <p className="text-[14px] font-bold text-[#060b4d] mt-0.5">{VERSION}</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3 px-4 py-3.5 rounded-xl bg-[#f5f5ff] border border-[#c8cbf0]">
                    <div className="w-8 h-8 rounded-lg bg-[#0613cc] flex items-center justify-center flex-shrink-0 shadow-[0_1px_6px_rgba(6,19,204,0.22)]">
                      <IcCalendar />
                    </div>
                    <div>
                      <p className="text-[10.5px] font-bold uppercase tracking-[0.55px] text-[#4a4d99]">Last Updated</p>
                      <p className="text-[14px] font-bold text-[#060b4d] mt-0.5">March 2026</p>
                    </div>
                  </div>

                </div>

                <p className="mt-4 text-[11.5px] text-[#0f6652] font-medium text-center">
                  Sales App Lite · Powered by{' '}
                  <a href="https://www.fidesm.dev" target="_blank" rel="noreferrer"
                    className="text-[#0f6652] font-bold hover:underline">
                    FIDES Management
                  </a>
                </p>
              </div>
            </div>

          </div>
        </main>
      </div>
    </>
  );
};

export default Settings;
